import { RefObject } from 'react';
import { VirtuosoHandle } from 'react-virtuoso';
import { v4 } from 'uuid';
import { MessageType } from 'types/chat.types';
import { ProfileCard } from 'types/profile';

export const scrollToIndex = (
  ref: RefObject<VirtuosoHandle>,
  index?: number
) => {
  if (ref && ref.current) {
    ref.current.scrollToIndex({
      index: index || 0,
      align: 'start',
      behavior: 'auto',
    });
  }
};

export const createRetryMessageTemplate = (
  message: string,
  user: ProfileCard
): MessageType => {
  const now = new Date();

  return {
    guid: `RETRY-${v4()}`,
    text: message,
    created: {
      timestamp: Math.round(now.getTime()),
      iso: now.toISOString(),
    },
    updated: {
      timestamp: Math.round(now.getTime()),
      iso: now.toISOString(),
    },
    needRetry: true,
    user,
    createdBy: {
      userGuid: user.subject,
    },
  };
};
